module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAMCAYAAABvEu28AAAACXBIWXMAAAsSAAALEgHS3X78AAAA7UlEQVQoz62SwU0DQQxFXyLuyZ2JRQcMHUw6gArYdBA6oANKCKkAOmA6yNIBsqaATQVwsVdWIsEi8GVk2f/J/uPZanX5yT/Ehb1HYAE8AP1EbQfcu3ZmE90Bj8AVUFTbtzCR1AE74N10L3OrDUABPoAqkvJESDEtDkK1/QgLkL1NPnhtHhtPYAcTnkFUWxch0WxvXpqJBajATiR5eYSIpC3wHGFu9tp+qwLXwI2vaDkBkoFD8CgDb77aMog2qq1XbYNqy+bHXrV1tn4PbKy3mnac6GjAW9VWpxyRSCrAq6XjHfHLY/TIwFOc6M/xBQTxaNcikJhIAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/Envelope.png
// module id = 176
// module chunks = 0 1